// extracted by mini-css-extract-plugin
module.exports = {"hero":"pe_hero__IPptZ","pricing":"pe_pricing__yfml_"};